module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/imgadvisor_spotlight_tablet_04@2x-7a9e0165f13c1fc6824ccf7ac3bccbca.jpg";